import axiosInstance from '../libs/axiosInstance';

export const getQuizzes = async ({ topic_id = null }) => {
  const response = await axiosInstance.get('/question_bank/quizzes/', {
    params: topic_id ? { topic_id } : {}
  });
  return response.data;
};

// Fetch quiz and format response
export const getQuiz = async (quizId) => {
  const response = await axiosInstance.get(`/question_bank/quizzes/${quizId}/`);
  return response.data;
};

export const getLecturerQuiz = async () => {
  const response = await axiosInstance.get('question_bank/lecturer-quizzes/')
  return response.data
}

export const getAdminQuiz = async () => {
  const response = await axiosInstance.get('question_bank/admin-quizzes/')
  return response.data
}

export const createQuiz = async (quizData) => {
  const response = await axiosInstance.post('/question_bank/quizzes/', quizData);
  return response.data;
};

export const updateQuiz = async (quizId, quizData) => {
  const response = await axiosInstance.put(`/question_bank/quizzes/${quizId}/`, quizData);
  return response.data;
};

export const deleteQuiz = async (quizId) => {
  await axiosInstance.delete(`/question_bank/quizzes/${quizId}/`);
};


// Submit quiz answers
export const submitQuizAnswers = async (sessionId, answers) => {
  const response = await axiosInstance.post(`/quiz-session/${sessionId}/submit/`, answers);
  return response.data;
};

// Get quiz session results
export const getQuizResults = async (sessionId) => {
  const response = await axiosInstance.get(`/quiz-session/${sessionId}/result/`);
  return response.data;
};

// Helper to build the question object with either quiz or question_bank
function buildQuestionPayload(questionData, { quizId = null, questionBankId = null }) {
  const question = {
    text: questionData.text,
    order: questionData.order || 0,
  };
  if (quizId) question.quiz = quizId;
  if (questionBankId) question.question_bank = questionBankId;
  if (questionData.image) question.image = questionData.image;
  return question;
}

function buildOptionPayload(option) {
  return {
    ...(option.id && { id: option.id }), // include id if present (for update)
    text: option.text,
    is_correct: option.is_correct || false,
    explanation: option.explanation, // fixed typo: explanaion -> explanation
  };
}

// Update theory question
export const updateTheoryQuestion = async (questionId, questionData, { quizId = null, questionBankId = null }) => {
  const payload = {
    question: buildQuestionPayload(questionData, { quizId, questionBankId }),
    vetting_method: questionData.vetting_method || 'onetime',
    answer: questionData.answer,
  };
  const response = await axiosInstance.put(`/question_bank/questions/${questionId}/theory/`, payload);
  return response.data;
};

// Update objective question
export const updateObjectiveQuestion = async (questionId, questionData, { quizId = null, questionBankId = null }) => {
  const payload = {
    question: buildQuestionPayload(questionData, { quizId, questionBankId }),
    options: questionData.options.map(buildOptionPayload),
    correct_explanation: questionData.correct_explanation,
    wrong_explanation: questionData.wrong_explanation,
  };
  const response = await axiosInstance.put(`/question_bank/questions/${questionId}/objective/`, payload);
  return response.data;
};

export const updateMatchingQuestion = async (questionId, questionData, { quizId = null, questionBankId = null }) => {
  const payload = {
    question: buildQuestionPayload(questionData, { quizId, questionBankId }),
    matching_pairs: questionData.matching_pair.map((pair) => ({
      id: pair.id,
      left: pair.left,
      right: pair.right,
    })),
  };
  const response = await axiosInstance.put(`/question_bank/questions/${questionId}/matching-questions/`, payload);
  return response.data;
}

// Update multiple select question
export const updateMultipleSelectQuestion = async (questionId, questionData, { quizId = null, questionBankId = null }) => {
  const payload = {
    question: buildQuestionPayload(questionData, { quizId, questionBankId }),
    options: questionData.options.map(buildOptionPayload),
    correct_explanation: questionData.correct_explanation,
    wrong_explanation: questionData.wrong_explanation,
  };
  const response = await axiosInstance.put(`/question_bank/questions/${questionId}/multiple-select/`, payload);
  return response.data;
};

// Delete question
export const deleteQuestion = async (questionId) => {
  await axiosInstance.delete(`/question_bank/questions/${questionId}/`);
};


// Create theory question
export const createTheoryQuestion = async (questionData, { quizId = null, questionBankId = null }) => {
  const payload = {
    question: buildQuestionPayload(questionData, { quizId, questionBankId }),
    vetting_method: questionData.vetting_method || 'onetime',
    answer: questionData.answer,
  };
  const response = await axiosInstance.post('/question_bank/theory-questions/', payload);
  return response.data;
};

// Create objective question
export const createObjectiveQuestion = async (questionData, { quizId = null, questionBankId = null }) => {
  const payload = {
    question: buildQuestionPayload(questionData, { quizId, questionBankId }),
    options: questionData.options.map(buildOptionPayload),
    correct_explanation: questionData.correct_explanation,
    wrong_explanation: questionData.wrong_explanation,
  };
  const response = await axiosInstance.post('/question_bank/objective-questions/', payload);
  return response.data;
};

// Create matching question
export const createMatchingQuestion = async (questionData, { quizId = null, questionBankId = null }) => {
  const payload = {
    question: buildQuestionPayload(questionData, { quizId, questionBankId }),
    matching_pairs: questionData.matching_pair.map((pair) => ({
      left: pair.left,
      right: pair.right,
    })),
  };
  const response = await axiosInstance.post('/question_bank/matching-questions/', payload);
  return response.data;
};

// Create multiple select question
export const createMultipleSelectQuestion = async (questionData, { quizId = null, questionBankId = null }) => {
  const payload = {
    question: buildQuestionPayload(questionData, { quizId, questionBankId }),
    options: questionData.options.map(buildOptionPayload),
    correct_explanation: questionData.correct_explanation,
    wrong_explanation: questionData.wrong_explanation,
  };
  const response = await axiosInstance.post('/question_bank/multiple-select-questions/', payload);
  return response.data;
};

export const bulkDeleteQuestions = async ({ quizId = null, questionBankId = null }) => {
  const params = {};
  if (quizId) params.quiz_id = quizId;
  if (questionBankId) params.question_bank_id = questionBankId;
  return axiosInstance.delete('/question_bank/questions/bulk-delete/', { params });
};